export const assessmentTypes = [
  { value: "SIPIL", label: "Sipil" },
  { value: "ELEKTRIK", label: "Elektrik" },
  { value: "K3L", label: "K3L" },
  { value: "MANPOWER", label: "Manpower" },
  { value: "GEDUNG", label: "Gedung" },
  { value: "TAMAN", label: "Taman" }
];

export const statusOptions = [
  { value: "NOT_STARTED", label: "Not Started", color: "default" },
  { value: "IN_PROGRESS", label: "In Progress", color: "warning" },
  { value: "COMPLETE", label: "Complete", color: "success" }
];

export const conditionOptions = [
  { value: "ADA_TEMUAN", label: "Ada Temuan" },
  { value: "TIDAK", label: "Tidak" }
];

export const sipilMasterData = {
  "A. STRUKTUR": [
    { subSection: "Balok", damageItems: ["Lendutan", "Retak", "Keropos", "Tulangan Terekspos"] },
    { subSection: "Kolom", damageItems: ["Retak", "Keropos", "Tulangan Terekspos"] },
    { subSection: "Plat Lantai", damageItems: ["Retak", "Lendutan", "Rembesan Air"] },
    { subSection: "Pondasi", damageItems: ["Retak Diagonal Dinding", "Lantai Dasar Ambles"] },
    { subSection: "Tangga", damageItems: ["Retak Pada Anak Tangga", "Retak Pada Balok Tangga", "Sambungan Plat Terekspos"] }
  ],
  "B. ARSITEKTUR": [
    {
      subSection: "ACP", damageItems: [
        "Noda pada ACP (Merubah Warna Dasar)",
        "Kondisi Panel (Dent, Scratch)",
        "Kondisi Sealant (Crack, Getas, Mengelupas)",
        "Panel Longgar",
        "Panel Tidak Rata",
        "Karat Pada Rangka"
      ]
    },
    {
      subSection: "Dinding", damageItems: [
        "Dinding (plesteran / cat mengelupas)",
        "Retak Rambut",
        "Cat Terkelupas"
      ]
    },
    {
      subSection: "Lantai", damageItems: [
        "Keramik Pecah",
        "Grouting Hancur",
        "Beton Terekspos",
        "Waterproofing"
      ]
    },
    {
      subSection: "Plafon", damageItems: [
        "Noda Air/Rembesan",
        "Karat/Keropos Pada Rangka",
        "Penutup Plafon (Sobek/Bolong/Melengkung)",
        "Cat Terkelupas"
      ]
    }
  ],
  "C. OUTDOOR AREA/UTILITAS SIPIL": [
    {
      subSection: "Atap", damageItems: [
        "Bubungan (retak / lepas)",
        "Penutup Atap (Melengkung / retak / lepas / pecah)",
        "Rangka Atap Melengkung Korosi/Lapuk deformasi",
        "Kebocoran Talang Horizontal",
        "Sambungan atau sealant (retak/hilang)",
        "Dak Beton Rembes / Retak (Jika ada)"
      ]
    },
    {
      subSection: "Dinding Penahan Tanah/Pagar", damageItems: [
        "Kemiringan DPT/Pagar",
        "Retak/Keropos/Karat",
        "Cat Terkelupas"
      ]
    },
    {
      subSection: "Drainase", damageItems: [
        "Saluran Tersumbat",
        "Manhole (Tidak Sesuai)",
        "Area Genangan Air Sekitar Gedung",
        "Kemiringan Drainase (Tidak Sesuai)"
      ]
    },
    {
      subSection: "Parkiran", damageItems: [
        "Tidak Adanya Marka",
        "Tidak Adanya Car Stopper"
      ]
    },
    {
      subSection: "Perkerasan (Pavement)", damageItems: [
        "Retak Aspal/Beton/Paving",
        "Lubang Aspal/Beton/Paving",
        "Ambles Aspal/Beton/Paving"
      ]
    }
  ],
  "D. TAMAN / HALAMAN": [
    { subSection: "Landscape", damageItems: ["Rawan Tumbang Pohon (Jika Ada)"] },
    { subSection: "Totem", damageItems: ["Totem Rusak"] }
  ],
  "E. SANITARY": [
    {
      subSection: "Floor Drain", damageItems: [
        "Kemiringan Lantai (Air Tidak Mengalir)",
        "Level Screeding Lantai Sesuai",
        "Floor Drain Tersumbat"
      ]
    },
    {
      subSection: "Kran Dinding", damageItems: [
        "Kebocoran Drat Dinding",
        "Tekanan Air Lemah"
      ]
    },
    {
      subSection: "Toilet", damageItems: [
        "Tersumbat Fungsi Flush (Closet/Urinal)",
        "Rembesan Pada Selang Flexible"
      ]
    },
    {
      subSection: "Wastafel", damageItems: [
        "Kebocoran Kran",
        "Lubang Overflow Tersumbat"
      ]
    }
  ],
  "F. PLUMBING": [
    {
      subSection: "Pipa Air Bersih dan Pipa Air Kotor", damageItems: [
        "Pipa Air Bersih dan Pipa Air Kontor (Bocor)",
        "Pipa Air Bersih dan Pipa Air Kontor (Sambungan Longgar)",
        "Tekanan Pipa Air Bersih (Kurang)",
        "Kemiringan Pipa Air Kotor (Tidak Sesuai)"
      ]
    },
    {
      subSection: "Pipa Air Hujan", damageItems: [
        "Sambungan Roof Drain Tidak Sesuai",
        "Roof Drain Tersumbat"
      ]
    },
    {
      subSection: "Saluran Limbah", damageItems: [
        "Kemiringan Saluran Tidak Sesuai",
        "Saluran Tersumbat"
      ]
    }
  ],
  "G. LAIN-LAIN": [
    { subSection: "Bak Pompa", damageItems: ["Keropos"] },
    { subSection: "Ground Water Tank (GWT)", damageItems: ["Retak/Bocor Dinding GWT", "Rembesan GWT"] },
    {
      subSection: "Pipa Hydrant & Sprinkle", damageItems: [
        "Karat pada Hydrant & Sprinkle",
        "Valve Terkunci",
        "Kelengkapan Aksesoris (Selang, Nozzle, Valve)",
        "Korosi Kepala Sprinkle"
      ]
    },
    {
      subSection: "Ramp Difabel", damageItems: [
        "Slope Ramp Sesuai",
        "Kelicinan (Material) Sesuai"
      ]
    },
    {
      subSection: "Septic Tank (STP)", damageItems: [
        "Retak/Bocor Dinding STP",
        "Elevasi Awal (Ambles) STP"
      ]
    },
    {
      subSection: "Waterprofing", damageItems: [
        "Rembesan Area Basah",
        "Coating Waterpofing Terkelupas"
      ]
    }
  ]
};
